import React from 'react';
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';

interface ConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  text: string;
  confirmText?: string;
  children?: React.ReactNode;
  // Gives the dialog a fixed, taller size - useful when children include a dropdown whose popup needs stable room to open in
  fixedHeight?: boolean;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  text,
  confirmText,
  children,
  fixedHeight,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={(_, data) => !data.open && onClose()}>
      <DialogSurface style={fixedHeight ? { width: "600px", maxWidth: "600px", height: "600px" } : undefined}>
        <DialogBody style={fixedHeight ? { height: "100%" } : undefined}>
          <DialogTitle
            action={
              <Button
                appearance="subtle"
                icon={<DismissRegular />}
                onClick={onClose}
              />
            }
          >
            {title}
          </DialogTitle>
          <DialogContent className="flex flex-col gap-2" style={fixedHeight ? { flexGrow: 1, overflowY: "auto" } : undefined}>
            <p className="text-sm">{text}</p>
            {children}
          </DialogContent>
          <DialogActions>
            <Button appearance="secondary" onClick={onClose}>
              Avbryt
            </Button>
            <Button appearance="primary" onClick={onConfirm}>
              {confirmText || 'Bekräfta'}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default ConfirmationDialog;
